import React from "react";
import './Reportes.css';
import { Tabs } from "antd";
import { Redirect } from 'react-router';
import ReporteInventario from "./InventarioOPL/ReporteInventario";
import ReporteProduccion from "./Produccion/ReporteProduccion";
import ReporteAprobacion from "./Aprobacion/ReporteAprobacion";
import ReporteAdjudicacion from "./Adjudicacion/ReporteAdjudicacion";
import ReporteRevision from "./Revision/ReporteRevision";
import BitacoraNotificaCion from "./Notificacion/BitacoraNotificacion";
import ReporteMedidas from "./MedidasSeguridad/ReporteMedidas";
import ReporteFormato from "./FormatoDiscapacidad/ReporteFormato";
import ValidacionDocumentos from "../Revision/Validacion/Validacion";


const { TabPane } = Tabs;
const permisos = localStorage.getItem('ROL_USUARIO');
let desactivar=false
class Reportes extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            
        };

    }
    

    componentDidMount() {

    }




    render() {
        if (this.state.redirect) {
            return <Redirect push to="/reportes" />;
        }
        
        return (
            <div>
                <h1 className="titulo-main-reportes">Reportes</h1>
                <h1 className="texto-16-reportes">Selecciona alguno de los reportes disponibles.</h1>

                <Tabs defaultActiveKey="1" tabPosition="top"  >

                    <TabPane tab="Inventario" key="1">
                        <div className="reporte">
                            <ReporteInventario />
                        </div>
                    </TabPane>
                    <TabPane tab="Revisión" key="9">
                        <div className="reporte">
                            <ReporteRevision />
                        </div>
                    </TabPane>
                    {!permisos.includes("DOCSYMAT.CAPTURA.OPLE.JL") && !permisos.includes("DOCSYMAT.CONSULTA.OPLE.JL") &&
                    <TabPane tab="Estatus notificación" key="3">
                        <div className="reporte">
                            <ValidacionDocumentos user = {this.props.user} location={this.props.location} isReporte = {true} />
                        </div>
                    </TabPane> }
                    <TabPane tab="Aprobación" key="4">
                        <div className="reporte">
                            <ReporteAprobacion />
                        </div>
                    </TabPane>
                    <TabPane tab="Adjudicación" key="5">
                        <div className="reporte">
                            <ReporteAdjudicacion />
                        </div>
                    </TabPane>
                    <TabPane tab="Producción" key="2">
                        <div className="reporte">
                            <ReporteProduccion />
                        </div>
                    </TabPane>
                    
                    {permisos.includes(".OC") === true &&
                    <TabPane tab="Bitácora" key="6">
                        <div className="reporte">
                            <BitacoraNotificaCion />
                        </div>
                    </TabPane>  }

                    <TabPane tab="Medidas de seguridad" key="7">
                        <div className="reporte">
                            <ReporteMedidas />
                        </div>
                    </TabPane>
                    <TabPane tab="Formato discapacidad" key="8">
                        <div className="reporte">
                            <ReporteFormato />
                        </div>
                    </TabPane>


                </Tabs>
            </div>
        );
    }
}

export default Reportes;